.tooltipWrapper {
	position: relative;
	display: inline-block;
	cursor: default;
}

.tooltipPanel {
	visibility: hidden;
	opacity: 0;
	position: absolute;
	top: calc(100% + 4px);
	left: 0;
	z-index: 1000;
	min-width: 38rem;
	background: #ffffff;
	border: 1px solid #d1d5db;
	border-radius: 8px;
	box-shadow: 0 8px 24px rgba(0, 0, 0, 0.14);
	transition:
		opacity 0.15s ease,
		visibility 0.15s ease;
	pointer-events: none;
}

.tooltipPanelTop {
	top: auto;
	bottom: calc(100% + 4px);
}

.tooltipWrapper:hover .tooltipPanel {
	visibility: visible;
	opacity: 1;
	pointer-events: auto;
}

.tooltipHead {
	display: flex;
	gap: 1.5rem;
	padding: 0.6rem 0.9rem;
	border-bottom: 1px solid #e5e7eb;
	background: #f9fafb;
	border-radius: 8px 8px 0 0;
}

.tooltipPercent {
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 0.1rem;
}

.percentLabel {
	font-size: 0.72rem;
	color: #6b7280;
	font-weight: 500;
}

.percentValue {
	font-size: 1.1rem;
	font-weight: 700;
	color: #1f2937;
}

.percentValueGreen {
	color: #16a34a;
}

.tooltipTable {
	width: 100%;
	border-collapse: collapse;
	font-size: 0.74rem;
}

.tableHeader {
	padding: 0.4rem 0.6rem;
	text-align: left;
	font-weight: 600;
	font-size: 0.7rem;
	color: #374151;
	background: #f3f4f6;
	border-bottom: 1px solid #e5e7eb;
	white-space: nowrap;
}

.tableHeaderNumeric {
	text-align: right;
}

.tooltipPanelStandalone {
	visibility: visible;
	opacity: 1;
	position: static;
	pointer-events: auto;
	min-width: 38rem;
	background: #ffffff;
	border: 1px solid #d1d5db;
	border-radius: 8px;
	box-shadow: 0 8px 24px rgba(0, 0, 0, 0.14);
}

.tableRow:nth-child(even) {
	background: #f9fafb;
}

.tableCell {
	padding: 0.38rem 0.6rem;
	color: #1f2937;
	border-bottom: 1px solid #f3f4f6;
	white-space: nowrap;
}

.tableCellNumeric {
	text-align: right;
	font-variant-numeric: tabular-nums;
}

.optionalRow {
	background: #f8fafc;
}

.optionalRow .tableCell {
	color: #475569;
	font-size: 0.74rem;
}

.optionalLine {
	display: inline-flex;
	align-items: baseline;
	gap: 0.15rem;
	padding-left: 0.35rem;
}

.optionPrefix {
	font-weight: 600;
	color: #6b7280;
}

.activeOptionalsAlert {
	display: inline-flex;
	align-items: center;
	justify-content: center;
}
